import { render, staticRenderFns } from "./fccTratamentoCandidatosTabela.vue?vue&type=template&id=60424c89"
import script from "./fccTratamentoCandidatosTabela.vue?vue&type=script&lang=js"
export * from "./fccTratamentoCandidatosTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports